import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementLicenceTypeForm from '../../../components/forms/EndorsementLicenceTypeForm';
import { useEndorsementLicenceTypeById, useUpdateEndorsementLicenceType } from '../../../hooks/useEndorsementLicenceTypeApi';
import { useNavigate, useParams } from 'react-router-dom';

const EndorsementLicenceTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useEndorsementLicenceTypeById(id);
  const updateMutation = useUpdateEndorsementLicenceType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    {
      label: 'Endorsement Licence Types',
      href: '/admin/endorsementlicencetypes',
    },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/endorsementlicencetypes');
    } catch (error) {
      console.error('Error updating EndorsementLicenceType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementlicencetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EndorsementLicenceType.Edit"
    >
        {entityData ? (
          <EndorsementLicenceTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/endorsementlicencetypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default EndorsementLicenceTypeEdit;
